import baseService from "@common/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  imprimirAlvara(data) {
    return http.post("/ObraProjetoAlvaraExterno/imprimirAlvara", data);
  },
  validarImprimirAlvara(data) {
    return http.post("/ObraProjetoAlvaraExterno/validarImprimirAlvara", data);
  },
  validarAlvara(data) {
    return http.post(`/ObraProjetoAlvaraExterno/ValidarAlvara`, data);
  },
  getAlvara(data) {
    return http.post(`/ObraProjetoAlvaraExterno/GetAlvara`, data);
  }
};

export default apiDef;
